import React, { FC } from 'react'
import { FlexContainer, Text2XL, TextBase, elM5, elFlex1, elHFull } from '@reapit/elements'
import { ErrorBoundary } from '@reapitform/utils'
import { cx } from '@linaria/core'
import { PageWrapper, BrandLogo } from '@reapitform/common-ui'
import StepNavigation from '../view/step-navigation'
import { useFormDocument } from '../view/layout/tenant-app-layout'

export const SuccessInfoSubmitedForm: FC = () => {
  const formDocumentData = useFormDocument()
  const formDisplayName = formDocumentData?.formDisplayName || 'Agreement'

  return (
    <ErrorBoundary>
      <StepNavigation hideTitleOnMobile>
        <PageWrapper hasFullPage>
          <FlexContainer isFlexColumn className={cx(elHFull, elFlex1)}>
            <BrandLogo src={formDocumentData?.agentLogoUrl || '/pwa-152x152.png'} />
            <Text2XL hasBoldText hasMargin tag="h2" hasCenteredText>
              Congratulations!
            </Text2XL>
            <TextBase className={cx(elM5)} hasRegularText hasCenteredText>
              Your {formDisplayName} is complete. We’ll be in touch once all parties have signed.
            </TextBase>
          </FlexContainer>
        </PageWrapper>
      </StepNavigation>
    </ErrorBoundary>
  )
}
